import AtriumApi from "api";

const documentsService = {
  listDocuments: async (params = {}) => {
    const { type, page = 1, per = 50 } = params;
    const queryParams = new URLSearchParams();
    if (type) queryParams.append("type", type);
    queryParams.append("page", page);
    queryParams.append("per", per);

    const response = await AtriumApi.get(`/v2/documents?${queryParams.toString()}`);
    return response.data;
  },

  getDocument: async (id) => {
    const response = await AtriumApi.get(`/v2/documents/${id}`);
    return response.data;
  },

  createDocument: async (artifact) => {
    const response = await AtriumApi.post("/v2/documents", {
      title: artifact.data?.title || artifact.title || "Untitled",
      type: artifact.type,
      data: artifact.data,
    });
    return response.data;
  },

  updateDocument: async (id, updates) => {
    const response = await AtriumApi.put(`/v2/documents/${id}`, updates);
    return response.data;
  },

  deleteDocument: async (id) => {
    const response = await AtriumApi.delete(`/v2/documents/${id}`);
    return response.data;
  },

  fetchDocumentData: async (dataUrl) => {
    const response = await fetch(dataUrl);
    if (!response.ok) throw new Error("Failed to fetch document data");
    return response.json();
  },
};

export default documentsService;
